<template>
    <div style="display:flex;justify-content: center; align-items: center; height: 91vh;">
    <Transition v-if="isLoading" name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>PROTO</span>
            </span>
        </div>
    </Transition>

        <v-form name="formConditions"
                class="shadow-box border border-gray-100 bg-white rounded-md shadow-md"
                style="border:1px solid #e0e0e0; padding:10px; width:60%">
            <Tabs value="0"
                  scrollable>

                <TabList>
                    <Tab value="0">{{ __('Report parameters') }}</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel value="0">
                        <div class="grid">
                            <FormCalendar fieldName="from_date"
                                          label="From"
                                          size="2"
                                          validation="required"
                                          :isFocus="true"
                                          v-model:field="conditions.from_date" />

                            <FormCalendar fieldName="to_date"
                                          label="To"
                                          size="2"
                                          validation="required"
                                          v-model:field="conditions.to_date" />

                            <FormSelect fieldName="user_id"
                                        label="User"
                                        :showClear="true"
                                        size="3"
                                        validation="required"
                                        :filter="(event) => onFilter(event, 'users')"
                                        :options="select?.users"
                                        v-model:field="conditions.user_id" />
                        </div>
                    </TabPanel>
                </TabPanels>

            </Tabs>
            <div class="grid">
                <Button :label="__('Create')"
                        icon="pi pi-check"
                        class="p-button-success"
                        style="margin:10px 5px;"
                        @click="createReport"></Button>
                <Button :label="__('Cancel')"
                        icon="pi pi-times"
                        class="p-button-secondary"
                        style="margin:10px 5px;"
                        @click="cancelOperation">
                </Button>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormSelect from "@crud/FormSelect.vue";
import FormCalendar from "@crud/FormCalendar.vue";
import Button from 'primevue/button';
import { router } from '@inertiajs/vue3';
import { __, makeReport } from '@pages/Helper/utils.js'
import { prepareSelect, onFilterService, validation } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------

const props = defineProps({
    reportParams: Object,
    conditions: { type: Object, default: {} }
})

const isLoading = ref(true);
const options = ["users"];
const select = ref(null);

const conditions = ref(props.conditions)

// -----------------------------------------------------

onBeforeMount(async () => {
    isLoading.value = true;
    select.value = await prepareSelect(options, null, conditions)
    isLoading.value = false;
});

// -----------------------------------------------------

const createReport = () => {
    if (validation(conditions.value, 'formConditions')) {
        makeReport(props.reportParams, conditions, isLoading)
    }
}

// -----------------------------------------------------

const cancelOperation = () => {
    router.get(route('report-index'));
}

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading, conditions, null, options);
}

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
